import Archives from './_archives';
import Manabi from './_manabi';
import Blog from './_blog';


export default class Main{
    
    constructor() {
        this._init();
    }


    _init(){
        this.$lower = document.querySelector('.l-lower');
        this.$main = window.parent.document.querySelector('.l-main');

        setTimeout(()=>{
            this._setPageSettings();
        }, 100);

        this. _setHashLink();
    }


    _setPageSettings(){
        this.gakunen = this.$main.getAttribute('data-gakunen');
        this.page = this.$main.getAttribute('data-page');
        this.$lower.classList.add(`-${this.page}`);

        // アーカイブス
        const $archives = document.querySelector('.archives');
        if($archives){
            const archives = new Archives();
        }

        // ブログ記事
        const $blog = document.querySelector('.blog');
        if($blog){
            const blog = new Blog();
        }

        // まなび基盤の記事
        const $keijiban = document.querySelector('.keijiban');
        if($keijiban){
            const manabi = new Manabi();
        }
    }


    _setHashLink(){

        [...document.querySelectorAll('.js-hash-link')].forEach($link =>{
            
            $link.addEventListener('click', e=>{
                e.preventDefault();

                const href = $link.getAttribute('href');

                if(href === './'){
                    const splitList = parent.location.href.split('/#/');
                    const split_2 = splitList[1].split('/');
                    
                    let url = splitList[0] + '/#/';
                    for(let i=0; i<split_2.length-1; i++){
                        url += `${split_2[i]}/`;
                    }

                    parent.location.href = url;
                }
                else{
                    const link1 = parent.location.href.split('#')[0] + '#/';
                    const link2 = href.replace('.html', '').split('/mvweb_2023/')[1];
                    parent.location.href = link1 + link2;
                }
            });
        });

        [...document.querySelectorAll('.js-hash-toplink')].forEach($link =>{
            
            $link.addEventListener('click', e=>{
                e.preventDefault();

                let url = `/chu5/mvweb_2023/${this.gakunen}/#/${this.page}/`
                if(this.page!='nanchu' && this.page!='otayori'){
                    url += `${this.gakunen}/`;
                }

                parent.location.href = url;
            });
        });
    }
}